/** Verhalten & Fähigkeiten — ein Knoten mit drei verknüpften Knoten: der
 *  Agent und was an ihm hängt (Learnings, Skills, MCP-Connectoren, Regeln).
 *  Agent-Menü „Verhalten & Fähigkeiten" (Marcel, 29.09.2026: „mehrere
 *  verknüpfte Elemente", statt `options-2-outline`). Aus drei Entwürfen
 *  gewählt (Person + Knoten, Orbi + Knoten, Netz): in Menügröße 20px liest
 *  sich das Netz am klarsten.
 *
 *  Symbolraster: 26er-Fläche, gezeichnet 22 (2–24), 2px Linie mit runden
 *  Enden, nur `currentColor`. Die Verbindungen enden an den Kreisrändern
 *  (Mittelpunkt-Richtung, Knoten r=2.5, Mitte r=4), keine Überlappung. */
export const agentSetupIcon = `
<svg width="100%" height="100%" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="14" r="4" stroke="currentColor" stroke-width="2"/>
<circle cx="13" cy="4.5" r="2.5" stroke="currentColor" stroke-width="2"/>
<circle cx="4.5" cy="20.5" r="2.5" stroke="currentColor" stroke-width="2"/>
<circle cx="21.5" cy="20.5" r="2.5" stroke="currentColor" stroke-width="2"/>
<path d="M13 10V7M9.82 16.43l-3.33 2.55M16.18 16.43l3.33 2.55" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>
`;
